<template>
  <router-view v-slot="{ Component }">
    <template v-if="Component">
      <suspense>
        <layout>
          <!-- main content -->
          <component :is="Component" />
          <!-- loading state -->
          <template #fallback> Loading... </template>
        </layout>
      </suspense>
    </template>
  </router-view>
</template>

<script setup lang="ts">
import { onErrorCaptured } from 'vue';
import { RouterView } from 'vue-router';
import { useErrorMessage } from '@/core/composables/useErrorMessage';
import Layout from '@/core/layouts/Index.vue';
import { useAppState } from '@/core/store/useAppState';

useAppState();

const { showErrorMessage } = useErrorMessage();

onErrorCaptured((error) => {
  console.error(error);

  if (!error) return;

  const { stack, message, name } = error;

  showErrorMessage({
    innerError: {
      name,
      message,
      stack,
    },
  });
});
</script>

<style scoped></style>
